export enum AutoOrderStrategy {
    MarketOptionAskOrderHedgedWithFeature = 1,
}
